import React, { useState, useEffect } from 'react';
import { get_myinv_basic_info } from '../../services/common';
import moment from 'moment';

const MyinvBasic = ({ myinvId }) => {
  const [basic, setBasic] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (myinvId) {
      getMyinvBasicInfo();
    }
  }, [myinvId]);

  const getMyinvBasicInfo = async () => {
    try {
      const userToken = localStorage.getItem('systemToken') || '';
      const response = await get_myinv_basic_info(userToken, myinvId);
      
      if (response.success === 200) {
        const basicData = response.basic;
        
        if (basicData === false) {
          alert('No Records found for this Investment');
        } else {
          // Format the data similar to Vue component
          const formattedBasic = {
            ...basicData,
            investment_valuation: `${basicData.currency_symbol}${(typeof basicData.investment_valuation !== 'undefined' ? basicData.investment_valuation.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
            investment_amount: `${basicData.currency_symbol}${(typeof basicData.investment_amount !== 'undefined' ? basicData.investment_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
            return: `${basicData.currency_symbol}${(typeof basicData.return !== 'undefined' ? basicData.return.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
            not_invested: `${basicData.currency_symbol}${(typeof basicData.not_invested !== 'undefined' ? basicData.not_invested.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
            growth: `${basicData.currency_symbol}${(typeof basicData.growth !== 'undefined' ? basicData.growth.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}`,
            issue_price: `${basicData.currency_symbol}${(typeof basicData.issue_price !== 'undefined' && !isNaN(basicData.issue_price) ? basicData.issue_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : basicData.issue_price)}`,
            yield: `${(typeof basicData.yield !== 'undefined' ? basicData.yield.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0)}%`,
            principle_paid: `${basicData.currency_symbol}${(typeof basicData.principle_paid !== 'undefined' && !isNaN(basicData.principle_paid) ? basicData.principle_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : basicData.principle_paid)}`,
            dividend_next_paid: moment(basicData.dividend_next_paid).format('DD/MM/YYYY'),
            maturity_date: moment(basicData.maturity_date).format('DD MMM, YYYY'),
            date_invested: moment(basicData.date_invested).format('DD MMM, YYYY'),
          };
          
          setBasic(formattedBasic);
        }
      }
    } catch (error) {
      console.error('Error fetching basic info:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <div className="w-full m-0">
        <div className="w-full">
          <div className="grid grid-cols-12 gap-0">
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Investment Valuation
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.investment_valuation}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Investment Duration
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.investment_duration}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Dividends Next Paid
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.dividend_next_paid}
              </p>
            </div>
            <div className="col-span-1 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                ROI
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                -
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                IRR
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                -
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-0 mt-2">
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Investment
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.investment}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Growth
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.growth}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Yield
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.yield}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Return
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.return}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-0 mt-2">
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Investment Amount
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.investment_amount}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Currency
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.currency_name}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Investment Period
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.investment_period}
              </p>
            </div>
            <div className="col-span-1 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Coupon
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.coupon}
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Subscription
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.subscription}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-0 mt-2">
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Date Invested
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.date_invested}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Issue Price
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.issue_price}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Number of Notes
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.no_of_notes}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Rank
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.rank}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Type
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.type}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Location
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.location}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-0 mt-2">
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Receipt
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.receipt}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Asset Type
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.asset_type}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Asset Sector
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.asset_sector}
              </p>
            </div>
            <div className="col-span-2 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Merchant Fees
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.merchant_fees}%
              </p>
            </div>
            <div className="col-span-3 p-0 border border-gray-300">
              <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                Maturity Dates
              </p>
              <p className="m-0 p-2 bg-white text-center text-sm">
                {basic.maturity_date}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyinvBasic;
